import styled from 'styled-components';

import { px } from '../../../../../contrib/ui';

export const CompleteEventStepStyled = styled.div`
  h4 {
    margin: 0;
    margin-top: ${px(10)};
  }

  .complete-event {
    p {
      width: 100%;
      margin: 0;
      margin-top: ${px(10)};
    }
  }
`;
